<div class="custom-gauge-card po-mb-2">
  <div class="gauge-title">{{ description }}</div>

  <div class="gauge-container">
    <div class="gauge-arc"></div>
    
    <div class="gauge-pointer" [style.transform]="'rotate(' + pointerRotation + 'deg)'"></div>

    <div class="gauge-center">
      <span class="gauge-percentage">{{ currentPercentage | number:'1.0-1' }}%</span>
      <span class="gauge-subtitle">de eficiência</span>
    </div>
  </div>

  <div class="gauge-legend">
    <span><i class="legend-color-box" style="background-color: #c64840;"></i> Lento</span>
    <span><i class="legend-color-box" style="background-color: #00b28e;"></i> Ideal</span>
    <span><i class="legend-color-box" style="background-color: #ea9b3e;"></i> Rápido</span>
  </div>
</div>